import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue"
import _imports_0 from './assets/img/sc-logo.svg'


const _hoisted_1 = { class: "single-page wrp" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "logo-block" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "logo",
    alt: "/",
    src: _imports_0
  })
], -1)
const _hoisted_4 = { class: "settings-block" }
const _hoisted_5 = {
  class: "link",
  href: "https://lexx-trade.com",
  target: "_blank"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "arrow-symbol" }, "⌄", -1)
const _hoisted_7 = { class: "footer" }
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = { class: "copyright" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_SqCalcForm = _resolveComponent("SqCalcForm")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("a", _hoisted_5, _toDisplayString(_ctx.$t('header.openPlatform')), 1),
        _createVNode(_component_el_dropdown, {
          class: "dropdown",
          trigger: "click",
          onCommand: _ctx.handleCommandLang
        }, {
          dropdown: _withCtx(() => [
            _createVNode(_component_el_dropdown_menu, null, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$i18n.availableLocales, (locale) => {
                  return (_openBlock(), _createBlock(_component_el_dropdown_item, {
                    key: `locale-${locale}`,
                    command: locale
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(locale.toUpperCase()), 1)
                    ]),
                    _: 2
                  }, 1032, ["command"]))
                }), 128))
              ]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _createElementVNode("span", null, [
              _createTextVNode(_toDisplayString(_ctx.$i18n.locale.toUpperCase()) + " ", 1),
              _hoisted_6
            ])
          ]),
          _: 1
        }, 8, ["onCommand"])
      ])
    ]),
    _createVNode(_component_SqCalcForm),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("span", {
        class: "text",
        innerHTML: _ctx.$t('footer.text')
      }, null, 8, _hoisted_8),
      _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t('footer.copyright', { year: new Date().getFullYear() })), 1)
    ])
  ]))
}